import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { EmailEventDTO } from '../../models/DTO/EventEmailDTO';

export interface IEventsService {
    //public IHttpActionResult Publish([FromBody] EventRaisedBase e)

    getEventEmails(): angular.IPromise<EmailEventDTO[]>;
    addOrUpdateEventEmail(alarmEmailDto: EmailEventDTO): angular.IPromise<EmailEventDTO>;
    deleteEventEmail(actionGuid: string, listenerGuid: string): angular.IPromise<void>;
}

export class EventsService implements IEventsService {
    static serviceId = 'eventsService';
    static $inject = ['requestService'];

    private readonly _eventsEmail = 'events/emails';

    constructor(private _requestService: IRequestService) {
    }

    getEventEmails(): angular.IPromise<EmailEventDTO[]> {
        return this._requestService.getAtV1<EmailEventDTO[]>(this._eventsEmail);
    }

    addOrUpdateEventEmail(dto: EmailEventDTO): angular.IPromise<EmailEventDTO> {
        return this._requestService
            .postAtV1<EmailEventDTO>(this._eventsEmail, dto)
            .then(data => {
                dto.guid = data.guid;
                dto.actionGuid = data.actionGuid;
                this._requestService.cleanCacheAtV1(this._eventsEmail);
                return data;
            });
    }

    deleteEventEmail(actionGuid: string, listenerGuid: string): angular.IPromise<void> {
        return this._requestService.postAtV1(`${this._eventsEmail}/delete/${actionGuid}/${listenerGuid}`)
        .then(data=>{
                this._requestService.cleanCacheAtV1(this._eventsEmail);
        });
    }
}